/**
 * RelatedEntityPills — ghost chips linking to related entities (e.g.,
 * challenges related to a framework, related challenges to a challenge).
 *
 * Aliases: related pills, entity pills, related chips
 */

import { Link } from "@tanstack/react-router";

import { CihSectionHeader } from "~/components/cih/section-header";

export type PillItem = { readonly label: string; readonly href: string };

type Props = {
  readonly items: ReadonlyArray<PillItem>;
  readonly sectionLabel: string;
  readonly heading: string;
};

export function RelatedEntityPills({ items, sectionLabel, heading }: Props) {
  if (items.length === 0) return null;

  return (
    <>
      <CihSectionHeader label={sectionLabel} title={heading} />
      <div className="mx-auto max-w-7xl px-4 pb-14 md:pb-20 xl:px-0">
        <div className="flex flex-wrap gap-2">
          {items.map((it) => (
            <Link
              key={it.href}
              to={it.href}
              className="inline-flex items-center gap-1.5 rounded-full border border-gray-300 px-3.5 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:border-purple-400 hover:text-purple-700"
            >
              {it.label} <span className="text-gray-400">→</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
